// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2tbyI","description":"PatientConsentPreview_description__1QmTR"};